import React from 'react';
import { withTranslation } from 'next-i18next';

class FormRow extends React.Component {
  render() {
    const {
      label,
      hideOptional,
      hint,
      hintUnderInput,
      name,
      value,
      defaultValue,
      inputType,
      inputMode,
      required,
      onChange,
      className,
      readOnly,
      pattern,
      min,
      max,
      step,
      pending,
      hidden,
      onBlur,
      onKeyDown,
      disabled,
      placeholder,
      extraClasses,
      Icon,
      autofocus,
      errorMessage,
      t,
    } = this.props;

    const id = `${name}Input`;
    const InputTag = inputType === 'textarea' ? inputType : 'input';
    const labelString = label;
    const hintString = hint;

    return (
      <div
        className={`c-form__row ${
          inputType === 'RTE' ? ' c-form__row--rte' : ''
        }  ${extraClasses || ''}`.trim()}
        hidden={hidden || inputType === 'hidden'}
      >
        {labelString && (
          <label className="c-form__label" htmlFor={id}>
            <span className="c-form__label-inner">
              {`${labelString}`}
              {!required && !hideOptional && (
                <small>&nbsp;({t('optional')})</small>
              )}
            </span>
            {!hintUnderInput && hintString && (
              <div className="c-form__hint" id={`${name}-hint`}>
                {hintString}
              </div>
            )}
          </label>
        )}

        <div
          className={`c-form__input-container ${
            Icon ? 'c-form__input-container--has-icon' : ''
          }`.trim()}
        >
          {['select', 'date'].indexOf(inputType) === -1 && (
            <>
              <InputTag
                type={inputType}
                inputMode={inputMode}
                id={id}
                data-cy={id}
                name={name}
                value={value}
                defaultValue={defaultValue}
                onChange={onChange}
                onBlur={onBlur}
                required={required}
                readOnly={readOnly || hidden}
                pattern={pattern}
                min={min}
                max={max}
                step={step}
                data-pending={pending}
                className={`c-input-text ${className ? `${className}` : ''} ${
                  Icon ? 'c-input-text--has-icon' : ''
                }`.trim()}
                aria-describedby={hint ? `${name}-hint` : ''}
                disabled={disabled}
                placeholder={placeholder}
                autoFocus={autofocus}
                onKeyDown={onKeyDown}
              />
              {!pending && Icon && <Icon className="c-form__icon" />}
              {pending && (
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  className="c-form__pending-spinner"
                >
                  <circle
                    cx="10"
                    cy="10"
                    r="8"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    pathLength="10"
                    strokeLinecap="round"
                  />
                </svg>
              )}
            </>
          )}
        </div>
        {!!hintUnderInput && hintString && (
          <div
            className="c-form__hint c-form__hint--under-input"
            id={`${name}-hint`}
          >
            {hintString}
          </div>
        )}
        {errorMessage && <div className="c-form__error">{errorMessage}</div>}
      </div>
    );
  }
}

FormRow.defaultProps = {
  inputType: 'text',
};

export default withTranslation()(FormRow);
